import React from "react";
import HeaderLogin from "./accountWidget";
import { attach } from "../common/componentExtensions";
import UIStore, { ScreenSize } from "../common/UIStore";
import { links } from "../routes";
import { CaldaieManagerIcon } from "../common/components/icons"
import logoText from "../assets/images/logo-light-text.png";

interface IProps {
  sidebarMinimized: boolean;
  screenType: ScreenSize;
}

export class Header extends React.Component<IProps> {

  onToggleSidebar = () => {
    UIStore.toggleSidebar();
  }

  render() {
    const { sidebarMinimized, screenType } = this.props;

    return (
      <>
        <header className="topbar d-print-none" style={{ position: "fixed", top: 0, width: "100%" }}>
          <nav className="navbar top-navbar navbar-expand-md navbar-light">
            <div className="navbar-header" style={{ paddingLeft: 10, paddingRight: 10 }}>
              <a href={links.landingUrl} className="navbar-brand" >
                <b>
                  <CaldaieManagerIcon color="white" width={35} />
                </b>
                <span style={{ display: screenType === ScreenSize.Mobile || sidebarMinimized ? "none" : "" }}>
                  <img src={logoText} alt="homepage" className="dark-logo" />
                  <img src={logoText} width={165} className="light-logo" alt="homepage" />
                </span>
              </a>
            </div>
            <div className="navbar-collapse">
              <ul className="navbar-nav me-auto mt-md-0" >
                <li className="nav-item">
                  <a
                    onClick={this.onToggleSidebar}
                    className="nav-link sidebartoggler hidden-md-up text-muted waves-effect waves-dark"
                  >
                    <i className="fa fa-bars" />
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={this.onToggleSidebar}
                    className="nav-link sidebartoggler hidden-sm-down text-muted waves-dark"
                  >
                    <i className="fa fa-bars" />
                  </a>
                </li>
              </ul>
              <ul className="navbar-nav my-lg-0">
                <HeaderLogin />
              </ul>
            </div>
          </nav>
        </header>

      </>
    );
  }
}
export default attach(Header, UIStore, (store, props) => {
  return { sidebarMinimized: store.sidebarMinimized, screenType: store.screenType }
});